module.exports = __webpack_public_path__ + "e83a1381c268bdf5370cdc039234b165.png";